import React, { Component } from 'react';
import { browserIsIE } from '../../../ie-support';

class CBTextAreaField extends Component {
  constructor(props) {
    super(props);
    this.state = { isValid: true, value: props.value, errors: '' };
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props;

    if (this.state.value != value) {
      this.setState({
        value
      });
    }
  };

  parseServerErrorMessages = () => {
    const { name, serverErrors } = this.props;
    if (serverErrors !== null && typeof serverErrors === 'object' && serverErrors[name]) {
      let concattedServerErrors = '';
      serverErrors[name].forEach(msgPart => {
        concattedServerErrors += `${msgPart} `;
      });
      return concattedServerErrors;
    }
    return undefined;
  };

  validateInput = elem => {
    const value = elem.target.value;
    const { validators, name, isValidCallback } = this.props;
    if (validators) {
      this.setState({ errors: '' });
      let validationErrors = '';
      let newValueIsValid = true;
      validators.forEach(validator => {
        if (!validator.validator(value)) {
          newValueIsValid = false;
          validationErrors += `${validator.errorMessage} `;
        }
      });
      isValidCallback(name, newValueIsValid);
      this.setState({ isValid: newValueIsValid, errors: validationErrors });
    }
  };

  handleChange = elem => {
    const value = elem.target.value;
    const { name, onChange, validateOnInput } = this.props;
    if (validateOnInput) {
      this.validateInput(elem);
    }
    this.setState({ value });
    // Always hand the value to the parent. The parent owns the value and
    // learns about validity separately through isValidCallback. Gating this
    // on the isValid read from state (stale, since validateInput's setState
    // has not applied yet) used to drop the first keystroke after the field
    // had been marked invalid: onChange was skipped, the parent re-rendered
    // with its old value, and componentDidUpdate reset the textarea to it.
    onChange({
      target: name,
      value,
    });
  };

  render() {
    const {
      labelStyle,
      labelTextStyle,
      labelText,
      name,
      type,
      step,
      placeholder,
      inputStyle,
      maxLength,
      disabled,
    } = this.props;

    const { value, errors } = this.state;
    return (
      <div style={browserIsIE() ? styles.fieldContainerIE : styles.fieldContainer}>
        <div style={labelStyle || styles.label}>
          <p className='font-titillium-web-semi-bold' style={labelTextStyle || styles.labelText}>
            {labelText}
          </p>
        </div>
        <textarea
          value={value}
          onChange={this.handleChange}
          onBlur={this.validateInput}
          name={name}
          placeholder={placeholder}
          style={{
            ...(inputStyle || styles.input),
            ...(disabled && styles.disabledInput)
          }}
          maxLength={maxLength}
          disabled={disabled}
        />
        <span style={styles.errorMessage}>
          {this.parseServerErrorMessages() || errors}
        </span>
      </div>
    );
  }
}

const styles = {
  fieldContainer: {
    marginBottom: 16,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
  },
  fieldContainerIE: {
    marginTop: 60,
    marginBottom: 16,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
  },
  input: {
    height: 175,
    width: '100%',
    resize: 'none',
    backgroundColor: 'rgb(235, 235, 235)',
    borderRadius: 16,
    fontSize: 14,
    border: 0,
    padding: 8,
  },
  disabledInput: {
    backgroundColor: 'rgb(245, 245, 245)',
    color: 'rgb(150, 150, 150)',
    cursor: 'not-allowed',
  },
  labelStyle: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 20,
  },
  labelTextStyle: {},
  errorMessage: {
    fontSize: 10,
    color: 'red',
  },
};

export default CBTextAreaField;
